<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M0.40332 11.0001C0.40332 8.18967 1.51977 5.49434 3.50705 3.50705C5.49434 1.51977 8.18967 0.40332 11.0001 0.40332C13.8106 0.40332 16.5059 1.51977 18.4932 3.50705C20.4805 5.49434 21.5969 8.18967 21.5969 11.0001C21.5969 13.8106 20.4805 16.5059 18.4932 18.4932C16.5059 20.4805 13.8106 21.5969 11.0001 21.5969C8.18967 21.5969 5.49434 20.4805 3.50705 18.4932C1.51977 16.5059 0.40332 13.8106 0.40332 11.0001ZM11.0001 1.92332C9.24079 1.92338 7.51939 2.43473 6.04534 3.39517C4.57129 4.3556 3.40812 5.72372 2.69735 7.33309C1.98658 8.94245 1.75883 10.7237 2.04182 12.4601C2.32481 14.1965 3.10634 15.8133 4.29132 17.1137C5.01072 15.9869 6.00255 15.0596 7.17514 14.4175C8.34772 13.7754 9.66324 13.4393 11.0001 13.4401C12.337 13.4391 13.6526 13.7752 14.8252 14.4173C15.9978 15.0594 16.9896 15.9868 17.7089 17.1137C18.8939 15.8133 19.6754 14.1965 19.9584 12.4601C20.2414 10.7237 20.0137 8.94245 19.3029 7.33309C18.5921 5.72372 17.429 4.3556 15.9549 3.39517C14.4809 2.43473 12.7595 1.92338 11.0001 1.92332ZM16.5713 18.1665C16.0051 17.1907 15.1924 16.3808 14.2146 15.8181C13.2368 15.2553 12.1283 14.9595 11.0001 14.9601C9.87195 14.9595 8.76342 15.2553 7.78562 15.8181C6.80783 16.3808 5.99511 17.1907 5.42892 18.1665C7.02054 19.4076 8.98182 20.0801 11.0001 20.0769C13.0993 20.0769 15.0321 19.3633 16.5713 18.1665ZM7.24012 9.40812C7.24012 8.41091 7.63626 7.45454 8.3414 6.7494C9.04654 6.04426 10.0029 5.64812 11.0001 5.64812C11.9973 5.64812 12.9537 6.04426 13.6588 6.7494C14.364 7.45454 14.7601 8.41091 14.7601 9.40812C14.7601 10.4053 14.364 11.3617 13.6588 12.0668C12.9537 12.772 11.9973 13.1681 11.0001 13.1681C10.0029 13.1681 9.04654 12.772 8.3414 12.0668C7.63626 11.3617 7.24012 10.4053 7.24012 9.40812ZM11.0001 7.16812C10.706 7.16812 10.4147 7.22606 10.1429 7.33863C9.87114 7.4512 9.6242 7.6162 9.4162 7.8242C9.2082 8.0322 9.0432 8.27914 8.93063 8.55091C8.81806 8.82268 8.76012 9.11396 8.76012 9.40812C8.76012 9.70228 8.81806 9.99356 8.93063 10.2653C9.0432 10.5371 9.2082 10.784 9.4162 10.992C9.6242 11.2 9.87114 11.365 10.1429 11.4776C10.4147 11.5902 10.706 11.6481 11.0001 11.6481C11.5942 11.6481 12.164 11.4121 12.584 10.992C13.0041 10.572 13.2401 10.0022 13.2401 9.40812C13.2401 8.81404 13.0041 8.24428 12.584 7.8242C12.164 7.40412 11.5942 7.16812 11.0001 7.16812Z'" />
</template>

<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    }
  }
}
</script>
